// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ywFk","content":"styles_content__3LdZZ","selectAll":"styles_selectAll__3T-n5"};